import { FunctionComponent } from 'react';
import PageSidebar from 'components/PageSidebar';
import PrivatePage from './PrivatePage';
import TrainingComponent from 'components/Training/TrainingComponent';
import { useServiceCategoryAccess } from 'hooks';
import { Redirect } from 'react-router-dom';
import { useFilteredServicesNavigation } from 'utils/PageSidebarUtils';

interface ServicesProps {
    create: string;
}

export const Training: FunctionComponent<ServicesProps> = props => {
    const { isAllowed, redirectTo } = useServiceCategoryAccess('training');
    const { selectedKey, setSelectedKey, sidebarItems } = useFilteredServicesNavigation('training');

    if (!isAllowed) {
        return <Redirect to={redirectTo} />;
    }

    const sidebar = (
        <PageSidebar
            title="Services"
            items={sidebarItems}
            selectedKey={selectedKey}
            onSelect={setSelectedKey}
        />
    );

    return (
        <PrivatePage
            title="Training - Cuddles"
            pageName="/training"
            pageSidebar={sidebar}
        >
            <TrainingComponent />
        </PrivatePage>
    );
};

export default Training;
